import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <p style={styles.code}>404</p>
        <h2 style={styles.heading}>Link Not Found</h2>
        <p style={styles.sub}>This attendance link is invalid or has expired.</p>
        <button onClick={() => navigate("/")} style={styles.btn}>Go Home</button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#0d0d0d",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'DM Mono', monospace",
    padding: "2rem",
  },
  card: {
    textAlign: "center",
    maxWidth: 380,
  },
  code: { fontSize: "5rem", fontWeight: 700, color: "#2a2a2a", margin: 0, lineHeight: 1 },
  heading: { fontSize: "1.4rem", color: "#f0f0f0", margin: "1rem 0 0.5rem", fontWeight: 700 },
  sub: { color: "#444", fontSize: "0.85rem", letterSpacing: "0.04em" },
  btn: {
    marginTop: "1.5rem",
    padding: "10px 24px",
    background: "#e8ff47",
    color: "#0d0d0d",
    border: "none",
    borderRadius: 3,
    fontSize: "0.82rem",
    fontWeight: 700,
    fontFamily: "'DM Mono', monospace",
    cursor: "pointer",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },
};
